// 64 × 64 = 4,096 combinations.

export const ADJECTIVES = [
  'claro','oscuro','vivo','calmo','dulce','fuerte','débil','ligero',
  'pesado','alto','bajo','ancho','estrecho','rápido','lento','amplio',
  'pálido','negro','blanco','rojo','azul','verde','amarillo','dorado',
  'plateado','cobre','ámbar','púrpura','coral','marfil','ceniza','escarlata',
  'frío','cálido','fresco','tibio','seco','húmedo','tierno','duro',
  'cortante','blando','liso','áspero','brillante','mate','puro','libre',
  'antiguo','nuevo','primero','último','profundo','fino','grueso','corto',
  'largo','redondo','cuadrado','delgado','grande','pequeño','noble','salvaje',
]

export const NOUNS = [
  'luna','sol','estrella','cielo','nube','viento','lluvia','nieve',
  'tormenta','arco','niebla','rocío','escarcha','rayo','alba','ocaso',
  'mar','río','lago','bosque','monte','valle','piedra','arena',
  'cueva','cascada','colina','llanura','isla','risco','orilla','prado',
  'rosa','lirio','iris','clavel','azahar','amapola','jazmín','lavanda',
  'orquídea','roble','arce','sauce','cedro','pino','haya','olmo',
  'ave','gorrión','golondrina','ruiseñor','águila','halcón','cuervo','garza',
  'cisne','lobo','zorro','liebre','ciervo','oso','lince','ardilla',
]
